import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.25 14.75H0.75V0.75H5.25V7.75M5.25 14.75H7.75H10.25M5.25 14.75V7.75M10.25 14.75H14.75V0.75H10.25V7.75M10.25 14.75V7.75M5.25 7.75H10.25",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset2;
